// extracted by mini-css-extract-plugin
module.exports = {"error_message":"ValidateEmailSetup_error_message__2Dptn"};